// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip.burner-analysis-tooltip .tooltip-inner {
    max-width: 360px;
    text-align: left;
    white-space: pre-line;
    font-size: 12px;
    line-height: 1.45;
    padding: 8px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/features/admin/burner_analysis/burner-analysis.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".tooltip.burner-analysis-tooltip .tooltip-inner {\n    max-width: 360px;\n    text-align: left;\n    white-space: pre-line;\n    font-size: 12px;\n    line-height: 1.45;\n    padding: 8px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
